import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { buildQuery } from '../exports/queryStringBuilder'
import { StorageCache } from '../exports/dataStorage'

const assetTypeKey = 'ams-asset-type-key'
const assetVendorKey = 'ams-asset-vendor-key'
const state = {
    types: null,
    vendors: [],
    assets: [],
    asset: null,
    assets_pagination: {},
    scheduleDate: '',
    asset_schedules: [],
    attachments: [],
    filters: {},
    query : '',
    temp_asset_rental: null,
}

const mutations = {
    updateScheduleDate(state, date) {
        state.scheduleDate = date
    },

    SET(state, payload) {
        state.assets = payload
    },

    SET_ASSET_PAGINATION(state, pag) {
        state.assets_pagination = pag
    },

    SET_ASSET(state, payload) {
        state.asset = payload
    },

    SET_FILTERS(state, payload) {
        state.filters = payload
    },
    SET_QUERY(state, payload) {
        state.query = payload
    },
    SET_TYPES(state, payload) {
        state.types = payload
    },

    SET_VENDORS(state, payload) {
        state.vendors = payload
    },
    SET_ATTACHMENTS(state, attachments) {
        state.attachments = attachments;
      },
      clearAssetsAttachments(state) {
        state.attachments = [];
    },
    SET_ASSET_RENTALS(state,items){
        state.temp_asset_rental = items;
    }
}

const actions = {
    ////asset
    async storeRentals(context,items){
        context.commit('SET_ASSET_RENTALS', items)
    },
    async get(context, id) {
        try {
            const resp = await axios.get(`asset/${id}`)
            console.log('get results', resp)
            const asset = resp.data.success.data
            context.commit('SET_ASSET', asset)
        } catch (err) {
            errorHandler(err)
        }
    },
    async getAsset(_,asset_id) {
        console.log('this is id-----',asset_id)
        try {
            const resp = await axios.get(`asset/${asset_id}`)
            console.log('get results', resp)
            const asset = resp.data.success.data
            return asset;
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetch(context, params) {
        try {
            let { query, page: pg, filters } = params || {}
            query = query || ''
            pg = pg || 0
            filters = filters || {}
            const path = `asset?q=${query}&page=${pg}&${buildQuery(filters)}`
            console.log('--path--', path)
            const results = await axios.get(path)
            console.log('fetch results', results)
            if (pg > 0) {
                let {
                    data,
                    current_page: page,
                    per_page: pageSize,
                    total,
                } = results.data.success.data
                console.log('....................', results.data.success.data)
    
                const pag = {
                    page,
                    pageSize,
                    total,
                }
                //const assets = data.data.success.data
                context.commit('SET', data)
                context.commit('SET_FILTERS', filters)
                context.commit('SET_QUERY', query)
                context.commit('SET_ASSET_PAGINATION', pag)
            } else {
                const { data } = results.data.success;
                context.commit('SET', data)
            }
        } catch (err) {
            console.error('asset fetch:', err)
            errorHandler(err)
        }
    },
    async fetch_master_item(context, params) {
        try {
            let { id } = params || {};
            if (!id) {
                console.error('No master item ID provided.');
                return;
            }
    
            const path = `asset/master_item/${id}`;
            const response = await axios.get(path);
            const final_data = response.data;
    
    
            return final_data;
        } catch (error) {
            console.error('Error fetching master item type:', error);
            throw error;
        }
    },
    
    async fetchSchedule(context, params) {
        try {
            let { query, filters } = params || {}
            query = query || ''
            filters = filters || {}
            const path = `asset?q=${query}&${buildQuery(filters)}`
            const results = await axios.get(path)
            console.log('fetch results', results)
            let data = results.data.success.data
            //const assets = data.data.success.data
            context.commit('SET', data)
        } catch (err) {
            console.error('asset fetch:', err)
            errorHandler(err)
        }
    },
    async fetchServiceHistory(context, params) {
        try {
            let { query, page: pg, filters, id } = params || {}

            query = query || ''
            pg = pg || 1
            filters = filters || {}
            const path = `asset/${id}?q=${query}&page=${pg}&${buildQuery(
                filters
            )}`
            console.log('--path--', path)
            const results = await axios.get(path)
            console.log('fetch results', results)
            let {
                current_page: page,
                per_page: pageSize,
                total,
            } = results.data.success.data
            const pag = {
                page,
                pageSize,
                total,
            }
            const asset = results.data.success.data
            context.commit('SET_ASSET', asset)
            context.commit('SET_ASSET_PAGINATION', pag)
        } catch (err) {
            errorHandler(err)
        }
    },
    async create(context, { payload }) {
        try {
            const data = await axios.post(`asset`, payload)
            console.log('create results', data)
            // context.dispatch('fetch') //not efficient
            //context.commit("SET_TYPE", data.success.data)
            return data.data.success.data
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, { id, payload }) {
        try {
            const data = await axios.put(`asset/${id}`, payload)
            console.log('update results', data)
            // context.dispatch('fetch') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async delete(context, id) {
        try {
            await axios.delete(`asset/${id}`)
            // context.dispatch('fetch') //not efficient
        } catch (err) {
            errorHandler(err)
        }
    },

    async listTypes(context) {
        try {
            const storageCache = new StorageCache(assetTypeKey)
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const data = await axios.get(`asset-type`)
                console.log('listType results', data)
                const types = data.data.success.data
                storageCache.set(types)
                value.splice(0)
                value.push(...types)
            }
            context.commit('SET_TYPES', value)
        } catch (err) {
            errorHandler(err)
        }
    },

    async createType(context, { name, description }) {
        try {
            new StorageCache(assetTypeKey).reset()
            const data = await axios.post(`asset-type`, { name, description })
            console.log('createType results', data)
            context.dispatch('listTypes') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateType(context, { id, name, description }) {
        try {
            new StorageCache(assetTypeKey).reset()
            const data = await axios.put(`asset-type/${id}`, {
                name,
                description,
            })
            console.log('updateType results', data)
            context.dispatch('listTypes') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteType(context, id) {
        try {
            new StorageCache(assetTypeKey).reset()
            await axios.delete(`asset-type/${id}`)
            context.dispatch('listTypes') //not efficient
        } catch (err) {
            errorHandler(err)
        }
    },

    //////////vendors
    async listVendors(context) {
        try {
            const storageCache = new StorageCache(assetVendorKey)
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const data = await axios.get(`asset-vendor`)
                console.log('listVendors results', data)
                const vendors = data.data.success.data
                storageCache.set(vendors)
                value.splice(0)
                value.push(...vendors)
            }
            context.commit('SET_VENDORS', value)
        } catch (err) {
            errorHandler(err)
        }
    },

    async createVendor(context, { name,description,notes,customer_id }) {
        try {
            new StorageCache(assetVendorKey).reset()
            const data = await axios.post(`asset-vendor`, { name, description,notes,customer_id })
            console.log('createVendor results', data)
            context.dispatch('listVendors') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateVendor(context, { id, name,description,notes,customer_id }) {
        try {
            new StorageCache(assetVendorKey).reset()
            const data = await axios.put(`asset-vendor/${id}`, {
                name,
                description,notes,customer_id
            })
            console.log('updateVendor results', data)
            context.dispatch('listVendors') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteVendor(context, id) {
        try {
            new StorageCache(assetVendorKey).reset()
            await axios.delete(`asset-vendor/${id}`)
            context.dispatch('listVendors') //not efficient
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchAttachments(context, asset_id) {
        console.log('attachment is called');
        try {
          if(context.rootState.assetAttachmentsStore.attachments.length > 0){
            return;
          }
          if (
            state.attachments.length > 0 &&
            state.attachments[0].asset_id == asset_id
          ) {
            return;
          }
          const result = await axios.get(`asset/${asset_id}/attachments`)
    
          context.commit("SET_ATTACHMENTS", result.data.success.data);
        } catch (err) {
          errorHandler(err);
        }
      },

      async exportExcelCSV(context, {filters_a,query_a }) {
        try {
            filters_a = filters_a || {};
            query_a = query_a || '';
    
          const response =await  axios.get(`asset/export-excel?q=${query_a}&` + buildQuery(filters_a),{
            responseType: 'blob'
        })
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "assets.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          console.error("Error fetching request:", err);
        }
      },
}

const getters = {
    getScheduleDate: state => state.scheduleDate,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
